import React, { Component } from 'react';

import './About.scss';

class About extends Component {
  render() {
    return (
      <div id="about" className="aboutUs">
        <h1><img src={require('./images/about.png')}/> </h1>
        <ul>
          <li>
            <a href="./aboutUs/company">
              <img src={require('./images/about-1.png')}/>
              <p>公司介绍</p>
            </a>
          </li>
          <li>
            <a href="./aboutUs/shareholder">
              <img src={require('./images/about-2.png')}/>
              <p>股东介绍</p>
            </a>
          </li>
          <li>
            <a href="./aboutUs/responsibility">
              <img src={require('./images/about-3.png')}/>
              <p>社会责任</p>
            </a>
          </li>
          <li>
            <a href="./aboutUs/honor">
              <img src={require('./images/about-4.png')}/>
              <p>公司荣誉</p>
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

export { About };



// WEBPACK FOOTER //
// ./modules/home/About.js